import { setSessionStorageString, getSessionStorageString } from './fnStorage';
import { SessionStorage } from '../types/Storage';

const PAGE_TITLE_KEY = 'currentPage' as keyof SessionStorage;

export const savePageInfo = (title: string): void => {
    setSessionStorageString(PAGE_TITLE_KEY, title);
};

export const getPageInfo = (): string => getSessionStorageString(PAGE_TITLE_KEY);
